import { ConfirmModal } from '@base-app';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactivateMemberModalProps } from './ReactivateMemberModal.types';

const ReactivateMemberModal: FC<ReactivateMemberModalProps> = ({ onCancel, onConfirm, show, selectedUserId }) => {
  const { t } = useTranslation(['teams', 'common']);
  return (
    <ConfirmModal
      cancelAction={{
        onClick: onCancel,
        text: t('modal_cancel', { ns: 'common' }),
      }}
      data={selectedUserId}
      confirmAction={{
        onClick: onConfirm,
        text: t('reactivate_modal_confirmation'),
      }}
      show={show}
      title={t('reactivate_modal_title')}
    />
  );
};

export default ReactivateMemberModal;
